
import { Component, Vue } from 'vue-property-decorator';
import MainHeader from '@/components/main-header.vue';
import BatchPrinting from '@/components/batch-printing.vue';
import AiTizhi from '@/components/template-transfer-pc/template/components/special/ai-tizhi.vue';
@Component({
    components: {
        MainHeader,
        BatchPrinting,
        AiTizhi,
    },
})
export default class EditWen extends Vue {
    private ifShowBatchPrinting: boolean = false;
    private selectedIds: any = [];
    private get patient() {
        return this.$store.state.patient;
    }
    private prev() {
        (this.$refs.aiTizhi as any).prev();
    }
    private goPrint(ids: any) {
        this.selectedIds = ids;
        this.ifShowBatchPrinting = true;
    }

    private save(data: any) {
        this.$router.back();
    }

}
